module.exports = __webpack_public_path__ + "ca234845cdc7117f7c8d6717f17d4879.png";